import type { ClientActionFunctionArgs, ShouldRevalidateFunctionArgs } from "react-router";

import { isNetworkFailureResult, submitOrFormFailure } from "~/lib/network-failure-result";

export { action, loader } from "./($lang)._index.loader.server";
export { default, meta } from "./($lang)._index.view";
export { RouteErrorBoundary as ErrorBoundary } from "~/components/route-error-boundary";

// SSR i18next must include "home" so useTranslation("home") resolves on the
// server and the hydrated text matches the client. `darkHero` gives the
// appbar its at-top dark treatment over the full-bleed hero (T226 D1).
export const handle = { i18n: ["home", "phases", "common"], darkHero: true };

/** T895 (F1) — a failed send keeps the waitlist form and her draft (`submitOrFormFailure`). */
export async function clientAction({ serverAction }: ClientActionFunctionArgs) {
  return submitOrFormFailure(serverAction, { ok: false, errors: { generic: true } } as const);
}

export function shouldRevalidate({ actionResult, defaultShouldRevalidate }: ShouldRevalidateFunctionArgs) {
  return isNetworkFailureResult(actionResult) ? false : defaultShouldRevalidate;
}
